import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom"
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
// Services
import AccountService from "../../../services/accountService";


function ModalAccountsUpload( {handleOpen, isOpen}) {

    const intFile = {
        size: 0,
        name: '',
        base64: ''
    }
    const navigate = useNavigate();
    const bcode = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/xlsx;";
    const [vfile, setFile] = useState(intFile);
    const [fileEnabled, setFileEnabled] = useState(false);
    
    const doImportButton = () => { 
        if(fileEnabled){
            try {
                let reader = new FileReader();
                reader.readAsDataURL(vfile);
                reader.onloadend = () => {
                    let model = {
                        file: bcode + reader.result.split(";")[1]
                    }
                    AccountService.setAccountUploadFile(model)
                    .then((response) => {
                        toast.success('Archivo importado correctamente!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })  
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }else{
                            sessionStorage.removeItem("userProfile");
                            navigate('/')
                            window.location.reload();
                        }
                    })
                    .finally(() => { handleOpen(false)})
                };
            } catch (error) {
                toast.error('ERROR! Al intentar importar el archivo.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
        }
    }

    const trgImport = (event) => { 
        if(event.target.files[0].size > 500000){
            toast.error('El archivo debe ser menor a 500KB!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
            setFileEnabled(false);
        }else if(event.target.files[0].type === "image/png" || event.target.files[0].type === "application/pdf" || event.target.files[0].type === ""){
            toast.error('El archivo debe ser un excel!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }else{
            setFile(event.target.files[0])
            setFileEnabled(true);
        }
    }

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Importar Archivo </DialogTitle>
                <Divider />
                <DialogContent>
                    <FormControl>
                        <FormLabel className="form-labels">Seleccione el archivo a Importar</FormLabel>
                        <input type="file" ng-model="file" name="file" maxsize="500" onChange={trgImport}></input>
                    </FormControl>
                    { vfile !== null &&
                        <div>
                            Archivo: <strong>{vfile.name}</strong><br/>
                            Tamaño: <strong>{vfile.size / 1000} KB</strong><br/>
                        </div>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info mb-2 d-grid w-100" onClick={doImportButton} disabled={!fileEnabled}>Importar</button>            
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalAccountsUpload;